<template>
  <div
    id="remove-wallet-modal"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-gray-700 rounded-lg shadow">
        <div
          class="flex items-center justify-between px-4 py-2 border-b border-gray-600 rounded-t"
        >
          <h3 class="font-semibold text-base uppercase">Remove wallet</h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent rounded-lg text-sm w-6 h-6 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white"
            @click="this.modal.hide()"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
        <div
          class="px-4 py-2 pb-8 max-h-[380px] overflow-y-auto space-y-2 pr-4"
        >
          <div class="flex justify-start gap-4 items-center pl-2 py-3">
            <div class="text-sm font-bold uppercase">
              Total: {{ this.wallets.length }} Wallet
            </div>
            <div class="w-[2px] h-[15px] bg-gray-500"></div>
            <div class="text-sm gap-1 flex items-center">
              <div class="font-bold text-red-400">
                {{ balanceFormat(this.totalBalanceNative) }}
              </div>
              <div class="text-sm">{{ this.wrappedToken }}</div>
            </div>
            <div
              class="bg-gray-800 uppercase shadow shadow-red-700 hover:shadow-red-600 px-4 py-1.5 text-sm font-bold rounded-xl cursor-pointer text-gray-300"
              @click="this.openConfirmRemoveAll"
            >
              Remove
            </div>
          </div>
          <remove-wallet
            v-for="wallet in this.wallets"
            :key="wallet.address"
            :wallet="wallet"
            :confirm="this.openConfirm"
          ></remove-wallet>
        </div>
      </div>
    </div>
  </div>
  <div
    id="confirm-remove-popup"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-3 w-full max-w-xs max-h-[200px]">
      <div class="relative rounded-lg shadow shadow-red-500 bg-gray-700">
        <div class="p-3 text-center">
          <svg
            class="mx-auto mb-2 w-8 h-8 text-gray-200"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          <h3 v-if="this.removeAllWallet" class="mb-3 text-sm text-gray-400">
            Are you sure you want to delete all wallets?
          </h3>
          <h3 v-else class="mb-3 text-sm text-gray-400">
            Are you sure you want to delete {{ this.wallet.name ?? "" }}?
          </h3>
          <div class="flex justify-center items-center gap-3">
            <button
              type="button"
              class="text-white bg-red-600 hover:bg-red-800 focus:outline-none rounded-xl text-sm inline-flex items-center px-3 py-1.5 text-center"
              @click="this.confirm(true)"
            >
              Yes, I'm sure
            </button>
            <button
              type="button"
              class="py-1.5 px-3 ms-3 text-sm focus:outline-none rounded-xl border focus:z-10 bg-gray-800 text-gray-400 border-gray-600 hover:text-white hover:bg-gray-700"
              @click="this.confirm(false)"
            >
              No, cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "flowbite";
import RemoveWallet from "@/components/RemoveWallet/RemoveWallet.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "RemoveWalletModal",
  components: { RemoveWallet },
  data() {
    return {
      modal: null,
      popup: null,
      removeAllWallet: false,
      wallet: {},
    };
  },
  computed: {
    ...mapGetters("app", ["balanceFormat"]),
    ...mapGetters("network", ["wrappedToken"]),
    ...mapGetters("wallet", [
      "totalBalanceNative",
      "totalBalanceToken",
      "wallets",
    ]),
    open() {
      return this.$store.state.removeWallet.open;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
  methods: {
    ...mapActions("wallet", ["remove", "removeAll"]),
    ...mapActions("removeWallet", ["show", "hide"]),
    openConfirm(wallet) {
      this.wallet = wallet;
      this.popup.show();
    },
    openConfirmRemoveAll() {
      this.removeAllWallet = true;
      this.popup.show();
    },
    async confirm(yes = true) {
      this.popup.hide();
      if (yes === true) {
        if (this.removeAllWallet) {
          await this.removeAll();
          this.modal.hide();
        } else {
          this.removeAllWallet = false;
          await this.remove(this.wallet);
          if (this.wallet.length === 0) {
            this.modal.hide();
          }
        }
      }
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("remove-wallet-modal"), {
      placement: "center",
      backdropClasses:
        "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
      onHide: () => {
        this.hide();
      },
    });
    this.popup = new Modal(document.getElementById("confirm-remove-popup"), {
      placement: "center",
      backdropClasses:
        "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
      closable: false,
    });
  },
  beforeUnmount() {
    this.hide();
  },
};
</script>
